import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Shuffle } from "lucide-react";
import { local } from "@/lib/api";
import { PageHeader } from "@/components/kit";
import { COPING_ACTIVITIES, FREE_SPACE } from "@/data/bingo";

const generate = () => {
  const pick = [...COPING_ACTIVITIES].sort(() => Math.random() - 0.5).slice(0, 24);
  return Array.from({ length: 25 }, (_, i) => (i === 12 ? { ...FREE_SPACE, done: true, free: true } : { ...pick[i < 12 ? i : i - 1], done: false }));
};

const LINES = [
  ...[0, 1, 2, 3, 4].map((r) => [0, 1, 2, 3, 4].map((c) => r * 5 + c)),
  ...[0, 1, 2, 3, 4].map((c) => [0, 1, 2, 3, 4].map((r) => r * 5 + c)),
  [0, 6, 12, 18, 24], [4, 8, 12, 16, 20],
];

export default function Bingo() {
  const [board, setBoard] = useState(() => (local.get("bingo_date", "") === new Date().toDateString() && local.get("bingo_board", null)) || generate());
  const [total, setTotal] = useState(local.get("total_bingos", 0));

  useEffect(() => { local.set("bingo_board", board); local.set("bingo_date", new Date().toDateString()); }, [board]);

  const lines = LINES.filter((l) => l.every((i) => board[i].done));
  const win = new Set(lines.flat());

  const tap = (i) => {
    if (board[i].free) return;
    const before = LINES.filter((l) => l.every((x) => board[x].done)).length;
    const nb = board.map((c, j) => (j === i ? { ...c, done: !c.done } : c));
    const after = LINES.filter((l) => l.every((x) => nb[x].done)).length;
    setBoard(nb);
    if (after > before) { const t = total + 1; setTotal(t); local.set("total_bingos", t); toast.success("BINGO! 🎉 You completed a line!"); }
  };

  return (
    <div className="max-w-2xl" data-testid="bingo-page">
      <PageHeader back title="Coping Bingo" subtitle="Complete healthy activities to get 5 in a row"
        right={<button className="mm-btn-ghost" onClick={() => setBoard(generate())} data-testid="bingo-new-board"><Shuffle size={16} />New board</button>} />
      <div className="flex gap-3 mb-5">
        <div className="mm-soft px-4 py-2 text-sm">Lines today: <b data-testid="bingo-lines">{lines.length}</b></div>
        <div className="mm-soft px-4 py-2 text-sm">All-time bingos: <b data-testid="bingo-total">{total}</b></div>
      </div>
      <div className="grid grid-cols-5 gap-2 sm:gap-3">
        {board.map((c, i) => (
          <button key={`${c.text}-${c.emoji}`} onClick={() => tap(i)} data-testid={`bingo-cell-${i}`}
            className={`aspect-square rounded-2xl p-1 sm:p-2 flex flex-col items-center justify-center text-center border-2 transition-all hover:scale-[1.03] ${c.done ? "text-white border-transparent" : "bg-mm-surface border-mm-line"}`}
            style={c.done ? { background: win.has(i) ? "var(--mm-success)" : "var(--mm-primary)" } : {}}>
            <span className="text-xl sm:text-3xl">{c.emoji}</span>
            <span className="text-[9px] sm:text-xs font-medium leading-tight mt-1">{c.text}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
